<template>
  <div class="actions-toolbar mb-4 sticky top-0 z-9 bg-primary6">
    <div class="actions-toolbar__nav bg-base rounded-2 pa-4 pb-4 flex justify-between items-center flex-wrap">
      <div class="breadcrumb-area flex justify-between gap-2 items-center truncate">
        <NBreadcrumb class="overflow-x-auto" separator=">">
          <NBreadcrumbItem
            class="text-lg tracking-[.25px] cursor-pointer"
            :style="{
              '--n-font-size': '18px',
            }"
            @click="onRootBreadcrumbClick"
          >
            {{
              store.state.viewMode === 'files'
                ? t('canvasUI.browserApp.fileSmartFolders.allFiles')
                : t('canvasUI.browserApp.fileSmartFolders.allSmartFolders')
            }}
          </NBreadcrumbItem>
          <NBreadcrumbItem
            v-for="(segment, index) in store.state.currentPath"
            :key="index"
            class="text-lg tracking-[.25px]"
            :class="{ 'cursor-pointer ': index !== store.state.currentPath.length - 1 }"
            :clickable="index !== store.state.currentPath.length - 1"
            :style="{
              '--n-font-size': '18px',
            }"
            @click="onBreadcrumbClick(index)"
          >
            <div class="text-lg tracking-[.25px]">
              {{ segment.property.display_name }}:
              <span class="font-bold">
                {{ Array.isArray(segment.value) ? segment.value.join(', ') : segment.value }}
              </span>
            </div>
          </NBreadcrumbItem>
        </NBreadcrumb>
      </div>
      <div class="flex justify-between items-center ml-auto gap-2">
        <CButton
          v-tooltip="t('canvasUI.browserApp.files.normalView')"
          circle
          icon
          icon-placement="left"
          @click="toggleSmartFoldersView"
        >
          <template #icon>
            <CIcon icon="table-list" size="16px" />
          </template>
        </CButton>
        <CButton
          v-tooltip="t('canvasUI.browserApp.files.configureSmartFolders')"
          circle
          icon
          icon-placement="left"
          @click="emit('configure')"
        >
          <template #icon>
            <CIcon icon="sliders-simple" size="16px" />
          </template>
        </CButton>

        <CButton
          v-if="
            (store.state.viewMode === 'files' && !isLastLevel) || (store.state.viewMode !== 'files' && !isRootLevel)
          "
          v-tooltip="
            store.state.viewMode === 'files'
              ? t('canvasUI.browserApp.files.viewAsFolders')
              : t('canvasUI.browserApp.files.viewAsFiles')
          "
          circle
          icon
          icon-placement="left"
          :type="store.state.viewMode === 'files' ? 'primary' : 'default'"
          @click="store.actions.toggleViewMode"
        >
          <template #icon>
            <CIcon :icon="store.state.viewMode === 'files' ? 'folder' : 'file'" size="16px" />
          </template>
        </CButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { NBreadcrumb, NBreadcrumbItem } from 'naive-ui'
import { useI18n } from 'vue-i18n'

import CButton from '@lib/components/CButton/CButton.vue'
import CIcon from '@lib/components/CIcon/CIcon.vue'
import useFileSmartFolderStore from '@browser/stores/fileSmartFolderStore'

const emit = defineEmits<{
  configure: []
  'breadcrumb-click': [index: number]
  'breadcrumb-reset': []
  search: [value: string]
}>()

const { t } = useI18n()
const store = useFileSmartFolderStore()

const isLastLevel = computed(
  () =>
    store.state.currentPath &&
    store.state.hierarchyLevels &&
    store.state.currentPath.length === store.state.hierarchyLevels.length,
)

const isRootLevel = computed(() => !store.state.currentPath?.length)

function toggleSmartFoldersView() {
  store.isSmartFoldersView.value = false
}

function onRootBreadcrumbClick() {
  store.actions.navigateToLevel(0)
  emit('breadcrumb-reset')
}

function onBreadcrumbClick(index: number) {
  emit('breadcrumb-click', index)
}
</script>
